import type { AxiosError } from "axios";
import type { ApiError } from "./api-error.ts";
import { extractMessageFromApi } from "../tools/helpers/MessageHelper.ts";
import { t } from "i18next";
import { lsClear } from "../tools/Storage.ts";
import { reloadPage } from "../tools/Routing.ts";

export function normalizeApiError(error: unknown): ApiError {
  if ((error as AxiosError)?.isAxiosError) {
    const axiosError = error as AxiosError<unknown>;
    const translatedError = extractMessageFromApi(axiosError, t);

    if (translatedError.message === t("apiError.INVALID_JWT")) {
      lsClear();
      reloadPage();
    }

    return {
      message: translatedError.message ?? t("error.unknownError"),
      status: axiosError.response?.status,
      details: axiosError.response?.data,
    };
  }

  if (error instanceof Error) {
    return { message: error.message };
  }

  return { message: t("error.unknownError") };
}
